import { combineReducers } from "redux";
import {
  authenticateUser,
  switchedSociety,
  groupWiseLevelData,
  userHasSocieties,
  userHasRoleWithPermission,
  switchedRole,
} from "./all-functions";

const reducers = combineReducers({
  user: authenticateUser,
  switchedSociety: switchedSociety,
  groupWiseLevelData: groupWiseLevelData,
  userHasSocieties: userHasSocieties,
  userHasRoleWithPermission: userHasRoleWithPermission,
  switchedRole: switchedRole,
});

export default reducers;
